import { render, staticRenderFns } from "./ListCtas.vue?vue&type=template&id=2de4854c&"
import script from "./ListCtas.vue?vue&type=script&lang=js&"
export * from "./ListCtas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports